exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "manage-purchase a.back{background-color:#fc0!important;text-decoration:none;text-align:center!important}manage-purchase a.back:hover{background-color:#ffde00!important;cursor:pointer}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/pages/manage-purchase/manage-purchase.styl
// module id = 894
// module chunks = 0